import React from 'react';
import { MdWarning } from 'react-icons/md';
import { Alert } from '@reach/alert';

import { Icon } from '../icon';
import { IconContainer } from '../icon-container';
import { ErrorDetails } from './error-details.component';

export type ErrorPanelProps = {
  title?: string;
  message?: string;
  error?: unknown;
};

export const ErrorPanel = ({
  title = 'Something went wrong',
  message,
  error,
}: ErrorPanelProps) => {
  const renderPanelContent = () => {
    if (error) {
      return <ErrorDetails error={error} />;
    } else if (message) {
      return <p className="font-medium">{message}</p>;
    } else {
      return null;
    }
  };
  return (
    <Alert className="space-y-4 text-center">
      <div>
        <IconContainer variant="danger">
          <Icon icon={<MdWarning />} />
        </IconContainer>
        <div className="text-red-700 text-2xl font-medium">{title}</div>
      </div>
      {renderPanelContent()}
    </Alert>
  );
};
